module.exports = __webpack_public_path__ + "static/media/naturevalley.3d59f314.png";